import gql from 'graphql-tag';
export var DiscordActivityMode;
(function (DiscordActivityMode) {
    DiscordActivityMode["Hosted"] = "HOSTED";
    DiscordActivityMode["Shared"] = "SHARED";
})(DiscordActivityMode || (DiscordActivityMode = {}));
export var DiscordActivityPlaySpeed;
(function (DiscordActivityPlaySpeed) {
    DiscordActivityPlaySpeed["One"] = "ONE";
    DiscordActivityPlaySpeed["OnePointFive"] = "ONE_POINT_FIVE";
    DiscordActivityPlaySpeed["OnePointTwo"] = "ONE_POINT_TWO";
    DiscordActivityPlaySpeed["Pause"] = "PAUSE";
    DiscordActivityPlaySpeed["PointEight"] = "POINT_EIGHT";
    DiscordActivityPlaySpeed["PointFive"] = "POINT_FIVE";
    DiscordActivityPlaySpeed["Three"] = "THREE";
    DiscordActivityPlaySpeed["Two"] = "TWO";
})(DiscordActivityPlaySpeed || (DiscordActivityPlaySpeed = {}));
export var DistanceUnit;
(function (DistanceUnit) {
    DistanceUnit["Kilometers"] = "KILOMETERS";
    DistanceUnit["Miles"] = "MILES";
    DistanceUnit["Unspecified"] = "UNSPECIFIED";
})(DistanceUnit || (DistanceUnit = {}));
export var EpisodeSort;
(function (EpisodeSort) {
    EpisodeSort["OldestFirst"] = "OLDEST_FIRST";
    EpisodeSort["RecentsFirst"] = "RECENTS_FIRST";
})(EpisodeSort || (EpisodeSort = {}));
export var GalleryLayout;
(function (GalleryLayout) {
    GalleryLayout["DescriptionTile"] = "DESCRIPTION_TILE";
    GalleryLayout["LargeTile"] = "LARGE_TILE";
    GalleryLayout["MiniTile"] = "MINI_TILE";
})(GalleryLayout || (GalleryLayout = {}));
export var GridLayout;
(function (GridLayout) {
    GridLayout["LargeTile"] = "LARGE_TILE";
})(GridLayout || (GridLayout = {}));
export var SearchContentType;
(function (SearchContentType) {
    SearchContentType["Audiobook"] = "AUDIOBOOK";
    SearchContentType["Category"] = "CATEGORY";
    SearchContentType["Episode"] = "EPISODE";
    SearchContentType["Event"] = "EVENT";
    SearchContentType["Game"] = "GAME";
    SearchContentType["Podcast"] = "PODCAST";
    SearchContentType["Program"] = "PROGRAM";
    SearchContentType["Show"] = "SHOW";
    SearchContentType["Station"] = "STATION";
    SearchContentType["Unknown"] = "UNKNOWN";
})(SearchContentType || (SearchContentType = {}));
export const AddUserConsentDocument = gql `
    mutation AddUserConsent($consent: ConsentInput) {
  addConsent(consent: $consent) {
    id
  }
}
    `;
export const GetUserDocument = gql `
    query GetUser($device: Device) {
  user(device: $device) {
    userId
    userName
    firstName
    lastName
    isFollowingListPublic
    isRegistered
    subscriptions {
      edges {
        node {
          status
          expiresOn
          providerId
          providerName
          key
        }
      }
    }
    email
  }
}
    `;
export const GetUserConsentsDocument = gql `
    query GetUserConsents($userId: String) {
  getUserConsents(userId: $userId) {
    simpleConsents {
      id
      userEmail
    }
  }
}
    `;
const defaultWrapper = (action, _operationName, _operationType) => action();
export function getSdk(client, withWrapper = defaultWrapper) {
    return {
        AddUserConsent(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(AddUserConsentDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), 'AddUserConsent', 'mutation');
        },
        GetUser(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(GetUserDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), 'GetUser', 'query');
        },
        GetUserConsents(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(GetUserConsentsDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), 'GetUserConsents', 'query');
        }
    };
}
